export default __webpack_public_path__ + "assets/home-two-two-small.19af6a3a42eb59ec6aabe9b5f2d651a7.png";